import apiPO from '../../../api/po';
import apiOption from '@/api/option';

const defaultState = () => ({
	listPO: [],
	detailPO: {},
	poPagination: '',
	OptionStatusPO: [],
	supplierResults: [],
	warehouseResults: [],
	OptionPO: [],
	supplierProducts: [],
	supplierProductsPagination: {},
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
	supplierProductsNotSelected (state) {
		return state.supplierProducts.filter( (el) => {
			return el.selected == false
		})
	},
	supplierProductsSelected (state) {
		return state.supplierProducts.filter( (el) => {
			return el.selected == true
		})
	},
	productPO(state){
		if (state.detailPO.po_detail) {
			return state.detailPO.po_detail.map((el, index) => {
				el.index = index
				el.quantity = el.po_detail_quantity_requested
				if (el.po_detail_schedule) {
					el.po_detail_schedule = el.po_detail_schedule.map((el) => {
						return {
							date: el.po_schedule_detail_date,
							quantity: el.po_schedule_detail_quantity
						}
					})
				}
				return el
			})
		}
	},
};

const mutations = {
	setPO(state, data) {
		state.listPO = data.data
		state.poPagination = data.pagination;
	},
	setDetailPO(state, data) {
		state.detailPO = data
	},
	setSupplier(state, data) {
		state.supplierResults = data
	},
	setWarehouse(state, data) {
		state.warehouseResults = data
	},
	setOptionStatusPO(state, data) {
		state.OptionStatusPO = data
	},
	setOptionPO(state, data){
		state.OptionPO = data
	},
	setSupplierProducts(state, data) {
		state.supplierProducts = data.data.map( (el) => {
			el.selected = false
			el.quantity = '1'
			return el
		});
		state.supplierProductsPagination = data.pagination
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataPO(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getPO({ commit }, params) {
		return new Promise((resolve) => {
			apiPO.getPO(params).then(({ data: { data } }) => {
				commit('setPO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setPO', { data: [], pagination: {} });
			});
		});
	},
	getPOAll({ commit }, params) {
		return new Promise((resolve) => {
			apiPO.getPOAll(params).then(({ data: { data } }) => {
				commit('setPO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setPO', { data: [], pagination: {} });
			});
		});
	},
	async getDetailPO({ commit, dispatch }, params) {
		await apiPO.detailPO(params).then(({ data: { data } }) => {
			commit('setDetailPO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailPO', {});
		});
	},
	getSupplierProducts({ commit }, params){
		apiPO.getSupplierProducts(params).then(({ data: { data } }) => {
			commit('setSupplierProducts', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setSupplierProducts', { data: [], pagination: {} });
		});
	},
	getSupplierOption({ commit }, params){
		return new Promise((resolve) => {
			apiOption.getOptionSupplier(params).then(({ data: { data } }) => {
				commit('setSupplier', data.results);
				resolve()
			}).catch(() => {
				commit('setSupplier', []);
			});
		});
	},
	getWarehouseOption({ commit }, params){
		return new Promise((resolve) => {
			apiOption.getOptionWarehouse(params).then(({ data: { data } }) => {
				commit('setWarehouse', data.results);
				resolve()
			}).catch(() => {
				commit('setWarehouse', []);
			});
		});
	},
	async exportPO({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiPO.exportPO(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Pemesanan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportPOAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiPO.exportPOAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Pemesanan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async getOptionPOforApprove({ commit }){
		await apiOption.getOptionPOforApprove().then( ({ data: { data } }) => {
			commit('setOptionPO', data.results);
		}).catch(() => {
			commit('setOptionPO', []);
		});
	},
	getOptionStatusPO({ commit }){
		return new Promise((resolve) => {
			apiPO.getOptionStatus().then( ({ data: { data } }) => {
				commit('setOptionStatusPO', data.results);
				resolve()
			}).catch(() => {
				commit('setOptionStatusPO', []);
			});
		});
	},
	async createPO({ commit, dispatch }, params) {
		await apiPO.createPO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Pemesanan'
			}, { root: true });
		});
	},
	async approvePO({ commit, dispatch }, params) {
		await apiPO.approvePO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menyetujui Pemesanan'
			}, { root: true });
		});
	},
	async rejectPO({ commit, dispatch }, params) {
		await apiPO.rejectPO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membatalkan Pemesanan'
			}, { root: true });
		});
	},
	async deletePO({ commit, dispatch }, params) {
		await apiPO.deletePO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus Pemesanan'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};